<div class="audit-page-choice-modal">
  <div class="audit-page-choice-modal__header">
    <pr-icon name="edit" [width]="20"></pr-icon>
    <h4>Modifier dans l’audit</h4>
  </div>

  <p class="audit-page-choice-modal__question">Quelle partie de l’audit voulez-vous modifier ?</p>

  <div class="audit-page-choice-modal__options" role="radiogroup">
    @for (page of pages; track page) {
      <button
        type="button"
        role="radio"
        class="audit-page-choice-modal__option"
        [class.audit-page-choice-modal__option--selected]="page === selected"
        [attr.aria-checked]="page === selected"
        (click)="selected = page"
      >
        <span class="audit-page-choice-modal__label">{{ labels[page] }}</span>
        @if (page === selected) {
          <pr-icon class="audit-page-choice-modal__check" name="check" [width]="18"></pr-icon>
        }
      </button>
    }
  </div>

  <div class="audit-page-choice-modal__actions">
    <pr-button size="lg" label="Annuler" (onClick)="cancel()"></pr-button>
    <pr-button size="lg" display="neutral" label="Ouvrir" [disabled]="!selected" (onClick)="confirm()"></pr-button>
  </div>
</div>
